<div class="modal-header mainColor">
    <h6 class="modal-title">{{"action_plan.analisis.methods_diagram.method_select" | translate}}</h6>
    <button type="button" class="close dangerButton" aria-label="Close" style="opacity: 1;" (click)="btnDismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" ngbAutofocus>
    <div class="container d-flex justify-content-center align-items-center" style="min-height:180px;">
        <div class="row">
            <div class="col-12 text-center">
                <h5 style="color: #126db3;">
                    {{"action_plan.analisis.methods" | translate}}
                </h5>
            </div>
            <div class="col-12 m-auto">
                <select name="" id="" class="col-12 form-control form-grey" (change)="selectMethod()"
                    [(ngModel)]="selectedMethod">
                    <option value="" disabled selected><em>{{select}}</em></option>
                    <ng-container *ngFor="let method of methods">

                        <option [value]="method.id">{{method.titulo}}</option>
                    </ng-container>
                </select>
            </div>
        </div>
    </div>


</div>
<div class="modal-footer">

    <button type="button" class="btn dangerButton" (click)="btnDismiss()"> {{"globals.buttons.cancelar" |
        translate}}</button>
    <button type="button" class="btn acceptButton" (click)="btnClose()">{{"globals.buttons.accept" |
        translate}}</button>

</div>